import { Link } from 'react-router-dom';
import React from 'react';

type Props = {
  onClick: () => void;
};

export const CommentCancelButton = (props: Props) => {
  return (
    <Link to="" className="d-inline-flex align-items-center" onClick={() => props.onClick()}>
      <i className="fas fa-undo me-1"></i>
      <span className="text-xs font-weight-bold">キャンセル</span>
    </Link>
  );
};
